export default "__VITE_ASSET__BGqk29Z0__ 400w, __VITE_ASSET__6ANX8nN$__ 800w, __VITE_ASSET__DWpdJXZf__ 1024w";